import React from 'react';
import { Box, Typography, Card, Grid, Alert, AlertTitle } from '@mui/material';
import { BarChart } from '@mui/x-charts/BarChart';

export const TabMetricas = ({ resumen }: { resumen: any }) => {
    const data = resumen?.detailedMetrics || { npsByArea: [], csatByArea: [], cesByArea: [] };

    return (
        <Grid container spacing={3}>
            {/* Mensaje Explicativo */}
            <Grid size={{xs: 12}}>
                <Alert severity="info" sx={{ borderRadius: 3, mb: 1, '& .MuiAlert-message': { width: '100%' } }}>
                    <AlertTitle sx={{ fontWeight: 800 }}>¿Cómo usar estas gráficas?</AlertTitle>
                    <Typography variant="body2" sx={{ lineHeight: 1.5 }}>
                        Estas gráficas te permiten visualizar qué áreas o servicios específicos están subiendo o bajando tu promedio general. Te ayuda a responder preguntas clave como: <strong>'Si mi calificación global bajó, ¿fue por por cual area?'</strong>. Úsalo para comparar el desempeño de tus diferentes departamentos y tomar decisiones precisas.
                    </Typography>
                </Alert>
            </Grid>

            {/* NPS */}
            <Grid size={{xs: 12}}>
                <Card sx={{ p: 3, borderRadius: 3, boxShadow: '0 4px 12px rgba(0,0,0,0.03)', border: '1px solid #f0f0f0', height: '100%' }}>
                    <Typography variant="h6" sx={{ fontWeight: 800, color: '#4ba804', mb: 1 }}>NPS por Área</Typography>
                    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 4 }}>
                        Net Promoter Score desglosado por las diferentes áreas del hotel o evento.
                    </Typography>
                    <Box sx={{ height: 350 }}>
                        <BarChart
                            dataset={data.npsByArea}
                            layout="horizontal"
                            yAxis={[{ scaleType: 'band', dataKey: 'area', tickLabelStyle: { fontSize: 11, fontWeight: 600 } }]}
                            series={[{ dataKey: 'nps', label: 'NPS', color: '#5DCC0A' }]}
                            height={350}
                            margin={{ left: 320, right: 30, top: 20, bottom: 30 }}
                        />
                    </Box>
                </Card>
            </Grid>

            {/* CSAT */}
            <Grid size={{xs: 12}}>
                <Card sx={{ p: 3, borderRadius: 3, boxShadow: '0 4px 12px rgba(0,0,0,0.03)', border: '1px solid #f0f0f0', height: '100%' }}>
                    <Typography variant="h6" sx={{ fontWeight: 800, color: '#673AB7', mb: 1 }}>CSAT por Área</Typography>
                    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 4 }}>
                        Satisfacción del Cliente (CSAT) desglosado por las diferentes encuestas.
                    </Typography>
                    <Box sx={{ height: 350 }}>
                        <BarChart
                            dataset={data.csatByArea}
                            layout="horizontal"
                            yAxis={[{ scaleType: 'band', dataKey: 'area', tickLabelStyle: { fontSize: 11, fontWeight: 600 } }]}
                            series={[{ dataKey: 'csat', label: 'CSAT', color: '#9C27B0' }]}
                            height={350}
                            margin={{ left: 320, right: 30, top: 20, bottom: 30 }}
                        />
                    </Box>
                </Card>
            </Grid>

            {/* CES */}
            <Grid size={{xs: 12}}>
                <Card sx={{ p: 3, borderRadius: 3, boxShadow: '0 4px 12px rgba(0,0,0,0.03)', border: '1px solid #f0f0f0', height: '100%' }}>
                    <Typography variant="h6" sx={{ fontWeight: 800, color: '#FF9800', mb: 1 }}>CES por Área</Typography>
                    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 4 }}>
                        Customer Effort Score (Esfuerzo del Cliente) desglosado por áreas.
                    </Typography>
                    <Box sx={{ height: 350 }}>
                        <BarChart
                            dataset={data.cesByArea}
                            layout="horizontal"
                            yAxis={[{ scaleType: 'band', dataKey: 'area', tickLabelStyle: { fontSize: 11, fontWeight: 600 } }]}
                            series={[{ dataKey: 'ces', label: 'CES', color: '#FF9800' }]}
                            height={350}
                            margin={{ left: 320, right: 30, top: 20, bottom: 30 }}
                        />
                    </Box>
                </Card>
            </Grid>
        </Grid>
    );
};
